
import { Building2, Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { SellerShareButtons } from "@/components/common/SocialShareButtons";

interface PublicListingsHeaderProps {
  seller: {
    full_name: string;
    business_name?: string;
    email?: string;
    phone_number?: string;
    profile_image_url?: string;
  };
  propertyCount: number;
  statusFilter?: 'active' | 'pending';
  sellerParam?: string;
}

const PublicListingsHeader = ({ seller, propertyCount, statusFilter = 'active', sellerParam }: PublicListingsHeaderProps) => {
  const label = statusFilter === 'pending' ? 'Pending' : 'Active';
  return (
    <div className="bg-godyspo-dark border-b border-border">
      <div className="container mx-auto px-4 py-8">
        <Card className="bg-card/50 backdrop-blur-sm">
          <CardContent className="p-6">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="flex-shrink-0">
                {seller.profile_image_url ? (
                  <img
                    src={seller.profile_image_url}
                    alt={seller.full_name}
                    className="w-20 h-20 rounded-full object-cover border-2 border-godyspo-gold"
                  />
                ) : (
                  <div className="w-20 h-20 rounded-full bg-godyspo-gold/20 flex items-center justify-center">
                    <Building2 className="h-8 w-8 text-godyspo-gold" />
                  </div>
                )}
              </div>
              
              <div className="flex-grow">
                <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                  {seller.business_name || seller.full_name}
                </h1>
                {seller.business_name && (
                  <p className="text-lg text-muted-foreground mb-2">{seller.full_name}</p>
                )}
                <p className="text-godyspo-gold font-medium mb-4">
                  {propertyCount} {label} {propertyCount === 1 ? 'Property' : 'Properties'}
                </p>
                
                <div className="flex flex-wrap gap-4 text-sm text-muted-foreground">
                  {seller.email && (
                    <div className="flex items-center gap-2">
                      <Mail className="h-4 w-4" />
                      <a href={`mailto:${seller.email}`} className="hover:text-godyspo-gold transition-colors">
                        {seller.email}
                      </a>
                    </div>
                  )}
                  {seller.phone_number && (
                    <div className="flex items-center gap-2">
                      <Phone className="h-4 w-4" />
                      <a href={`tel:${seller.phone_number}`} className="hover:text-godyspo-gold transition-colors">
                        {seller.phone_number}
                      </a>
                    </div>
                  )}
                </div>

                {sellerParam && (
                  <div className="mt-4">
                    <SellerShareButtons
                      sellerParam={sellerParam}
                      sellerName={seller.business_name || seller.full_name}
                    />
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PublicListingsHeader;
